export default __webpack_public_path__ + "static/media/home-page.8cb44299.png";